export default __webpack_public_path__ + "static/media/integrated-text.507eb0bc.png";